module.exports = __webpack_public_path__ + "images/made-with-rails-29439e05a7d1fedaaf560e3f473770f2.png";